import React from 'react';
import { X, Check, Settings2 } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
const comparisons = [{
  sin: 'Vibración a 40 km/h sin solución',
  con: 'Protocolo Anti-Wobble. Eliminado permanentemente'
}, {
  sin: 'Motor corta en subidas de verano',
  con: 'Pad térmico 12W/mK + protocolo térmico. -22°C'
}, {
  sin: 'Rueda lenta y sin respuesta',
  con: 'PID ajustado para tu peso exacto'
}, {
  sin: 'Presión de fábrica genérica',
  con: 'Tabla de performance por peso y superficie'
}, {
  sin: 'No sabés qué upgrades hacer primero',
  con: 'Jerarquía Tier 1/2/3 con ROI calculado'
}];
export function ProComparison() {
  return <AnimatedSection className="py-24 relative" data-id="element-207">
      <div className="container mx-auto px-4 md:px-6" data-id="element-208">
        <div className="max-w-4xl mx-auto" data-id="element-209">
          <div className="text-center mb-12" data-id="element-210">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 flex items-center justify-center gap-3" data-id="element-211">
              <Settings2 className="w-8 h-8 text-brand-yellow" data-id="element-212" />
              ¿Qué agrega el Configuración PRO?
            </h2>
            <p className="text-xl text-brand-yellow font-medium" data-id="element-213">
              50 páginas de tuning avanzado. Firmware, hardware y técnica
              corporal.
            </p>
          </div>

          <div className="bg-brand-surface border border-brand-border rounded-xl overflow-hidden" data-id="element-214">
            <div className="grid grid-cols-2 bg-brand-dark border-b border-brand-border" data-id="element-215">
              <div className="p-4 md:p-6 text-center font-bold text-zinc-400" data-id="element-216">
                Sin Configuración PRO
              </div>
              <div className="p-4 md:p-6 text-center font-bold text-brand-yellow bg-brand-yellow/5" data-id="element-217">
                Con Configuración PRO
              </div>
            </div>

            <div className="divide-y divide-brand-border" data-id="element-218">
              {comparisons.map((item, index) => <div key={index} className="grid grid-cols-2" data-id="element-219">
                  <div className="p-4 md:p-6 flex items-start gap-3 text-zinc-400" data-id="element-220">
                    <X className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-221" />
                    <span className="text-sm md:text-base" data-id="element-222">{item.sin}</span>
                  </div>
                  <div className="p-4 md:p-6 flex items-start gap-3 text-white bg-brand-yellow/5" data-id="element-223">
                    <Check className="w-5 h-5 text-brand-yellow shrink-0 mt-0.5" data-id="element-224" />
                    <span className="text-sm md:text-base font-medium" data-id="element-225">
                      {item.con}
                    </span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}